export function maskingName(str: any) {
  let originStr = str;
  let strLength;
  if (!originStr) {
    return originStr;
  }
  strLength = originStr.length;
  let startPos = Math.round(strLength * 0.3);
  let endPos = Math.round(strLength * 0.7);
  if (strLength === 2) {
    endPos = 2;
  }
  return originStr.substring(0, startPos) + ''.padEnd(endPos - startPos, '*') + originStr.substring(endPos);
}

export function maskingEmail(str: any) {
  const originStr = str;
  if (!originStr) {
    return originStr;
  }
  if (originStr.indexOf('@') === -1) {
    return str;
  }
  let temp = originStr.split('@');
  // let elength = temp[0].length;
  temp[0] = temp[0].substr(0, 2);
  temp[0] = temp[0].padEnd(5, '*');
  return temp[0] + '@' + temp[1];
}
